import { Link } from '@sketch/components'
import React, { FC } from 'react'

import {
  Container,
  Thumbnail,
  Name,
  NoImageThumbnail,
  NoImageIcon,
} from './ProfileDocument.styles'

interface ProfileDocumentProps {
  thumbnail: string
  name: string
  url: string
}

export const ProfileDocument: FC<ProfileDocumentProps> = ({
  thumbnail,
  name,
  url,
}) => {
  return (
    <Link to={url}>
      <Container title={name}>
        {thumbnail ? (
          <Thumbnail src={thumbnail} alt={name} />
        ) : (
          <NoImageThumbnail>
            <NoImageIcon aria-label="No Image available" />
          </NoImageThumbnail>
        )}
        <Name>{name}</Name>
      </Container>
    </Link>
  )
}
